import { Box, Grid, Alert, AlertTitle, Typography, TextField } from '@mui/material';
import BackdropComponent from '../../../../components/Backdrop/BackdropComponent';
import { DrawerHeader } from '../../../../components/Drawer/DrawerHeader';
import { TranslateFunction } from '../../../../hooks/useTranslate';
import { Visita } from '../../consts/visitasTypes';

interface SeeCancelMotiveDrawerProps {
    translate: TranslateFunction;
    selected: Visita | null;
    setOpen: (value: boolean) => void;
    actionType: string;
}

const SeeCancelMotiveDrawer = ({
    translate,
    selected,
    setOpen,
    actionType
}: SeeCancelMotiveDrawerProps) => {
    const closeDrawer = () => {
        setOpen(false);
    };
    const motive = selected?.observacion || '';

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            padding={1}
            sx={{ flexDirection: 'column', height: '100%' }}
        >
            <Grid>
                <DrawerHeader
                    onIconClick={closeDrawer}
                    text={translate(`drawer.title.${actionType?.toLowerCase()}`)}
                />
                <Grid item xs={12}>
                    <TextField
                        label={translate('drawers.sendVisitToRevision.fields.motive')}
                        multiline
                        rows={20}
                        fullWidth
                        variant="outlined"
                        value={motive}
                        onChange={() => {}}
                        disabled={true}
                        error={motive.length > 0 && motive.length < 10}
                    />
                </Grid>
            </Grid>
            <BackdropComponent />
        </Box>
    );
};

export { SeeCancelMotiveDrawer };
